(function() {
    'use strict';

    a3_cabin_reports.controller('ModuleHistoryCtrl', ModuleHistoryCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name ModuleHistoryCtrl
     * @description 
     *
     * @ngInject
     */
    function ModuleHistoryCtrl($scope, $routeParams, TrainingSessionFactory, CourseFactory, FlightSessionFactory, $location) {
        $scope.rightScroll = rightScroll;
        $scope.leftScroll = leftScroll;
        $scope.selectedTrainee = selectedTrainee;
        $scope.selectedSession = selectedSession;
        $scope.gotoCourse = gotoCourse;     

        var isGround = false;
        if($routeParams.dutyId) {
            isGround = true;
            var courseId = Number($routeParams.courseId);
            var dutyId = Number($routeParams.dutyId);
            var date = $routeParams.date;
            var phaseId = Number($routeParams.phaseId);
        }
        else {
            var courseId = Number($routeParams.courseId);
            var dutyNo = Number($routeParams.dutyNo);
            var dutyDay = Number($routeParams.dutyDay);
            var date = $routeParams.date;
            var phaseId = Number($routeParams.phaseId);
        }

        CourseFactory.getCourseFromStorage(courseId, function (course) {
            $scope.phase = course.CrewCoursePhases.find(x => x.PhaseId == phaseId);
            $scope.course = course;          
            if(isGround) {
                TrainingSessionFactory.getSessionTrainees(courseId, date, dutyId, function (trainees) {     
                    initHistory(trainees);              
                });
            }
            else {
                FlightSessionFactory.getSessionTrainees(courseId, date, dutyNo, dutyDay, function (trainees) {               
                    initHistory(trainees);              
                });
            }
        });
        
        function initHistory(trainees) {
            if (trainees && trainees.length) {
                trainees.forEach(function (trainee) {
                    trainee.HistoryPhase = trainee.Phases.find(x => x.PhaseId == phaseId);
                });
                $scope.historyTrainees = setHistoryTrainees(trainees);

                $scope.selectedTraineeBadge = {
                    crewId: trainees[0].CrewId,
                    traineeSessionId: trainees[0].HistoryPhase.Sessions[0].Id
                };

                $scope.selectedSubmittedSessionBadge = {
                    sessionId: trainees[0].HistoryPhase.Sessions[0].SessionId
                };
            }
        }

        function setHistoryTrainees(trainees){
            var historyTrainees = trainees.filter(x => x.HistoryPhase && x.HistoryPhase.Sessions && !x.Session.Absent);

            historyTrainees.forEach(function(trainee){

                trainee.HistoryPhase.hasSectors = trainee.HistoryPhase.Sessions.some(x => x.Sectors && x.Sectors.length>0);
                trainee.HistoryPhase.Sessions.forEach(function(session){
                    session.hasDayGrading = session.DayGrading.Comments || (session.DayGrading.GradeType != 'NotSet' && session.DayGrading.Grade) || session.DayGrading.Competences.length>0;
                    session.hasReleaseGrading = session.ReleaseGrading.Comments || (session.ReleaseGrading.GradeType != 'NotSet' && session.ReleaseGrading.Grade) || session.ReleaseGrading.Competences.length>0;
                    session.AcTypes = [...new Set(session.Sectors.map(ses => ses.AcType))];

                    //GroupBy AcType
                    session.SectorsByAcType = [];
                    session.AcTypes.forEach(function(acType){
                        var group = {
                            AcType: acType,
                            Sectors: session.Sectors.filter(x => x.AcType == acType)
                        };
                        session.SectorsByAcType.push(group);
                    });
                });

                setTraineeSummary(trainee.HistoryPhase);
                
            });

            return historyTrainees;
        }

        function setTraineeSummary(phase){
            var sectorSummary = [];
            var totalSectors = 0;

            //Unique ac types of all sessions
            var allAcTypes = [];
            phase.Sessions.forEach(function(session){
                allAcTypes = allAcTypes.concat(session.AcTypes);
            });

            allAcTypes = [...new Set(allAcTypes)];

            //Group by ac type
            allAcTypes.forEach(function(acType){
                var sectors = [];
                phase.Sessions.forEach(function(session){
                    sectors = sectors.concat(session.Sectors.filter(x => x.AcType == acType));
                });

                var sectorGroup = {
                    AcType: acType,
                    Sectors: sectors
                };

                totalSectors = totalSectors + sectors.length;
                sectorSummary.push(sectorGroup);
            });


            phase.SectorSummary = sectorSummary;
            phase.TotalSectors = totalSectors;

        }

        function selectedTrainee() {   
            return function( trainee ) {
                var showSession = false;
                if (trainee.CrewId === $scope.selectedTraineeBadge.crewId){
                    showSession = true;
                }
                return showSession;
            };
        }

        function selectedSession() {  
            return function( historyTrainee ) {
                var showSession = false;
                if (historyTrainee.SessionId === $scope.selectedSubmittedSessionBadge.sessionId){
                    showSession = true;
                }
                return showSession;
            };
        }      

        function leftScroll() {
            document.querySelector('.horizontal-scroll').scrollLeft -= 500;
        }
        
        function rightScroll() {
            document.querySelector('.horizontal-scroll').scrollLeft += 500;
        }

        function gotoCourse() {
            if(isGround) {
                $location.path('/groundcourse/' + Number($routeParams.courseId) +  '/' + Number($routeParams.dutyId) + '/' +  $routeParams.date);
            }
            else {
                 $location.path('/flightcourse/' + Number($routeParams.courseId) +  '/' + Number($routeParams.dutyNo) + '/' + Number($routeParams.dutyDay) + '/' +  $routeParams.date);
            }
           
        }

    }
})();